// extracted by mini-css-extract-plugin
module.exports = {"container":"forgot-password_container__1-iwJ","box":"forgot-password_box__3Xsfg","logo":"forgot-password_logo__1mYCf","button":"forgot-password_button__3n1Op"};